// SPDX-License-Identifier: AGPL-3.0-or-later
// KONVO: "Hide the sidebar behind the Konvo logo" (Appearance > Sidebar). Off
// by default and kept per device: the desktop icon rail takes no space and
// unrolls out of a logo in the top-left corner on hover or click. Phones
// never read it.

import {makePersistent} from '@app/features/platform/utils/MobXPersistence';
import {makeAutoObservable} from 'mobx';

export const HIDDEN_SIDEBAR_STORAGE_KEY = 'HiddenSidebar';

class HiddenSidebarStore {
	enabled = false;
	pinDurationSeconds = 60;

	constructor() {
		makeAutoObservable(this, {}, {autoBind: true});
		void makePersistent(this, HIDDEN_SIDEBAR_STORAGE_KEY, ['enabled', 'pinDurationSeconds'], {syncAcrossTabs: true});
	}

	get pinDurationMs(): number {
		const seconds = this.pinDurationSeconds;
		return (Number.isFinite(seconds) ? Math.min(600, Math.max(15, seconds)) : 60) * 1000;
	}

	setPinDurationSeconds(seconds: number): void {
		this.pinDurationSeconds = Number.isFinite(seconds) ? Math.min(600, Math.max(15, Math.round(seconds))) : 60;
	}

	setEnabled(enabled: boolean): void {
		this.enabled = enabled;
	}
}

export default new HiddenSidebarStore();
